export { EventDetailAttendeesList } from "./EventDetailAttendeesList";
